@if (usageOverviewDialog.minimized() && !usageOverviewDialog.pinnedToSidenav()) {
<div
    #widget
    class="usage-overview-minimized"
    [class.usage-overview-minimized--loading]="usageOverviewDialog.loading()"
    [class.usage-overview-minimized--dragging]="isDragging()"
    [class.usage-overview-minimized--cancellation-pending]="
        cancellationPending() && !usageOverviewDialog.loading()
    "
    [style.left.px]="position().x"
    [style.top.px]="position().y"
    role="button"
    tabindex="0"
    [attr.aria-label]="'billingStatusWidget.restore' | translate"
    [attr.aria-busy]="usageOverviewDialog.loading()"
    (pointerdown)="onPointerDown($event)"
    (pointermove)="onPointerMove($event)"
    (pointerup)="onPointerUp($event)"
    (pointercancel)="onPointerUp($event)"
    (click)="onWidgetClick()"
    (keydown.enter)="onWidgetClick()"
    (keydown.space)="onWidgetClick(); $event.preventDefault()">
    <div class="usage-overview-minimized__header">
        <span class="usage-overview-minimized__title">
            <mat-icon class="usage-overview-minimized__drag-icon" aria-hidden="true">drag_indicator</mat-icon>
            {{ 'billingStatusWidget.minimizedTitle' | translate }}
        </span>
        @if (usageOverviewDialog.loading()) {
        <mat-progress-spinner
            class="usage-overview-minimized__loader"
            color="primary"
            diameter="16"
            mode="indeterminate"
            [attr.aria-label]="'billingStatusWidget.loading' | translate" />
        } @else {
        <span
            class="usage-overview-minimized__count"
            [attr.aria-label]="
                'billingStatusWidget.minimizedClaims'
                    | translate: tParams({ count: claimCount() })
            ">
            {{ claimCount() }}
        </span>
        }
    </div>
    @if (!usageOverviewDialog.loading()) {
    <div
        class="usage-overview-minimized__progress"
        role="progressbar"
        [attr.aria-valuenow]="progressPercent()"
        aria-valuemin="0"
        aria-valuemax="100">
        <span
            class="usage-overview-minimized__progress-fill"
            [style.width.%]="progressPercent()"></span>
    </div>
    }
    <div class="usage-overview-minimized__footer">
        @if (!usageOverviewDialog.loading()) {
            @if (cancellationPending()) {
            <div class="usage-overview-minimized__footer-meta">
                <span
                    class="usage-overview-minimized__tier-badge usage-overview-minimized__tier-badge--cancel"
                    matTooltipClass="usage-overview-widget-tooltip"
                    matTooltipPosition="above"
                    [matTooltip]="
                        'billingStatusWidget.summary.cancelEndsHint'
                            | translate: tParams({ date: cancellationEndDateLabel()! })
                    ">
                    {{ 'billingStatusWidget.minimizedCancelScheduled' | translate }}
                </span>
                <button
                    type="button"
                    class="usage-overview-minimized__keep-button"
                    [disabled]="
                        usageOverviewDialog.loading() || reverseCancellation.reversing()
                    "
                    [attr.aria-label]="'billingStatusWidget.reverseCancellation.button' | translate"
                    (click)="keepService($event)">
                    {{ 'billingStatusWidget.reverseCancellation.button' | translate }}
                </button>
            </div>
            } @else {
                @if (currentServicePlan(); as plan) {
                <span class="usage-overview-minimized__tier-badge">
                    {{
                        'billingStatusWidget.usage.tierMarker'
                            | translate: tParams({
                                tier: plan.tier,
                                threshold: tierMarkerThreshold()!
                            })
                    }}
                </span>
                }
            }
        }
        <div class="usage-overview-minimized__actions">
            <button
                type="button"
                class="usage-overview-minimized__icon-button"
                matTooltipClass="usage-overview-widget-tooltip"
                [matTooltip]="'billingStatusWidget.pinToSidenav' | translate"
                [attr.aria-label]="'billingStatusWidget.pinToSidenav' | translate"
                (click)="pinToSidenav($event)">
                <mat-icon>push_pin</mat-icon>
            </button>
            <button
                type="button"
                class="usage-overview-minimized__icon-button"
                matTooltipClass="usage-overview-widget-tooltip"
                [matTooltip]="'billingStatusWidget.refresh' | translate"
                [disabled]="usageOverviewDialog.loading()"
                [attr.aria-label]="'billingStatusWidget.refresh' | translate"
                (click)="refresh($event)">
                <mat-icon>refresh</mat-icon>
            </button>
            <button
                type="button"
                class="usage-overview-minimized__icon-button"
                matTooltipClass="usage-overview-widget-tooltip"
                [matTooltip]="'billingStatusWidget.close' | translate"
                [attr.aria-label]="'billingStatusWidget.close' | translate"
                (click)="close($event)">
                <mat-icon>close</mat-icon>
            </button>
        </div>
    </div>
</div>
}

